import { Blocks, BookCheck, GalleryHorizontal, PawPrint } from "lucide-react";
import React from "react";


export default function TravelFooter() {
  return (<>
    <footer className="travel-footer">

      {/* background image container */}
      <div
        className="travel-bg"
        style={{
          backgroundImage: `url('/mnt/data/Screenshot 2025-11-15 213618.png')`,
        }}
      >
        {/* translucent overlay panel */}
        <div className="overlay-panel">
          {/* top centered logo */}
          <div className="panel-logo">
            <div className="logo-box">
              <div className="plane"><PawPrint size={20}/></div>
              <div className="logo-text">Join Now</div>
            </div>
          </div>

          {/* columns */}
          <div className="panel-grid">

            {/* Quick Links */}
            <div className="col col-links">
              <h4>Quick Links</h4>
              <ul>
                <li>➜ Blog</li>
                <li>➜ Page</li>
                <li>➜ Explore</li>
                <li>➜ Testimonials</li>
                <li>➜ Contact</li>
              </ul>
            </div>

            {/* Get In Touch */}
            <div className="col col-contact">
              <h4>Get In Touch</h4>

              <div className="contact-line">777 Franklin St, San Francisco</div>
              <div className="contact-line">+1 600-123-456-7890</div>
              <div className="contact-line">Ask@traveltourtheme.com</div>

              <div className="social-row">
                <span className="social-circle">f</span>
                <span className="social-circle">t</span>
                <span className="social-circle">in</span>
                <span className="social-circle">y</span>
              </div>
            </div>

            {/* Posts */}
            <div className="col col-posts">
              <h4>Courses</h4>

              <div className="post-item">
                <div className="post-thumb" />
                <div className="post-text">
                  <div className="arrow">➜</div>
                  <div>Course 1</div>
                   <div className="post-subttl">Subtitle 1</div>
               
                </div>
              </div>

              <div className="post-item">
                <div className="post-thumb" />
                <div className="post-text">
                  <div className="arrow">➜</div>
                   <div>Course 2</div>
                   <div className="post-subttl">Subtitle 2</div>
               
                </div>
              </div>

              <div className="buy-row">
                <button className="buy-btn">BUY NOW</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* bottom black stripe with center logo and nav */}
      <div className="bottom-stripe">
        <div className="bottom-inner">
          <div className="copyright">© Travel Themes 2020 - All Rights Reserved.</div>

          <div className="center-logo-mini">
            <div className="mini-square">
              <div className="plane-mini">Explore Classes</div>
            </div>
          </div>

          <nav className="bottom-nav">
            <a href="#">Contact</a>
            <a href="#">Blog</a>
            <a href="#">Page</a>
            <a href="#">Cart</a>
            <a href="#">Shop</a>
          </nav>
        </div>
      </div>
    </footer>
    <style>{`/* TravelFooter.css - drop in same folder and import above */
:root{
  --overlay-bg: rgba(12,12,12,0.85);
  --accent: rgba(144, 202, 249,1); /* yellow used in screenshot */
  --light: #f5f5f5;
}

/* Footer root */
.travel-footer {background: rgba(144, 202, 249,0.51);
  width: 100%;
  margin: 0;margin-top:50px;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}
.post-subttl{font-size:12px; color:#aaaaaa}
/* Background image area */
.travel-bg{
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 80px 6% 40px;
  position: relative;
}

/* big rounded translucent panel centered */
.overlay-panel{
  max-width: 1100px;
  margin: 0 auto;
  background: var(--overlay-bg);
  border-radius: 14px;
  padding: 36px 44px 28px;
  color: #fff;
  box-shadow: 0 6px 22px rgba(0,0,0,0.45);
  position: relative;
}

/* top centered logo area */
.panel-logo{
  position: absolute;
  top: -36px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-box{
  background: var(--light);
  color: #222;
  padding: 10px 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.2);
}

.plane{
  font-size: 22px;
  transform: translateY(-1px);
}

.logo-text{
  font-weight: 800;
  letter-spacing: 1px;
  font-size: 20px;
}

/* grid for columns */
.panel-grid{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 26px;
  margin-top: 18px;
  align-items: start;
}

/* column headings */
.overlay-panel h4{
  font-size: 20px;
  margin-bottom: 18px;
  font-weight: 700;
  color: #fff;
}

/* Quick links list */
.col-links ul{
  list-style: none;
  padding: 0;
  margin: 0;
}
.col-links li{
  margin-bottom: 14px;
  font-size: 16px;
  color: rgba(255,255,255,0.95);
}

/* contact column */
.contact-line{
  margin-bottom: 12px;
  color: rgba(255,255,255,0.9);
  font-size: 15px;
}

/* fake social circles */
.social-row{
  margin-top: 14px;
  display:flex;
  gap:10px;
}
.social-circle{
  width:42px;
  height:42px;
  border-radius:50%;
  border:2px solid rgba(255,255,255,0.85);
  display:flex;
  align-items:center;
  justify-content:center;
  color: #fff;
  font-weight:700;
  background: transparent;
}

/* posts column */
.post-item{
  display:flex;
  gap:12px;
  align-items:center;
  margin-bottom: 16px;
}
.post-thumb{
  width:72px;
  height:72px;
  background: #222;
  border-radius:6px;
  flex: 0 0 72px;
  background-size: cover;
  background-position:center;
 
  /* left as gradient placeholder; you can add thumbnails via inline style */
}
.post-text{
  font-size:15px;
  line-height:1.05;
  color: #fff;
}
.arrow{
  display:inline-block;
  margin-right:8px;
  color: #fff;
  opacity: 0.95;
  margin-bottom:6px;
}

/* buy row */
.buy-row{
  margin-top: 8px;
}
.buy-btn{
  background: var(--accent);
  color: #111;
  font-weight: 800;
  padding: 12px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display:inline-block;
}

/* bottom stripe */
.bottom-stripe{
  background: #0a0a0a;
  color: #ddd;
  padding: 18px 6%;
}
.bottom-inner{
  max-width: 1200px;
  margin: 0 auto;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: 16px;
}

/* center mini logo */
.center-logo-mini{
  display:flex;
  align-items:center;
  justify-content:center;
}
.mini-square{
  background: var(--accent);
  padding:1px 25px;
  height: 60px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:4px;
}
.plane-mini{
  font-size:20px;color:#222222;font-weight:bolder;
}

/* bottom nav */
.bottom-nav{
  display:flex;
  gap:18px;
}
.bottom-nav a{
  color:#fff;
  text-decoration:none;
  font-weight:600;
  opacity:0.95;
}

/* responsive */
@media (max-width: 900px){
  .overlay-panel{
    padding: 28px;
  }
  .panel-grid{
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .panel-logo{ top: -30px; }
  .bottom-inner{ flex-direction: column; gap: 10px; text-align:center; }
}
`}</style>
    </>
  );
}
